/**
 * @author Gustavo Jimenez <soygus@gmail.com>
 */
import React from "react";
import PropTypes from "prop-types";

const TurnIcon = (props) => {
  const { onClick } = props;
  return (
    <div className="turnIcon" onClick={onClick}>
      <ion-icon name="sync-circle"></ion-icon>
    </div>
  );
};

TurnIcon.propTypes = { onClick: PropTypes.func };

export default TurnIcon;
